import { Button } from "@kamae-apps/shared/Components/Atoms/Button/Button"
import { Tatami } from "@kamae-apps/shared/Components/Atoms/Tatami/Tatami"
import { FC } from "react"
import { RepairIllustration } from "./Components/RepairIllustration/RepairIllustration"
import { useErrorFallback } from "./useErrorFallback"

export enum ERROR_FALLBACK_LAYOUT {
  FULL_SCREEN = "full-screen",
  PAGE = "page",
}

type ErrorFallbackProps = {
  error: Error
  layout: ERROR_FALLBACK_LAYOUT
}

export const ErrorFallback: FC<ErrorFallbackProps> = ({ error, layout }) => {
  const { t, isRecovering, isStillFailing, reload } = useErrorFallback(error)
  const isFullScreen = layout === ERROR_FALLBACK_LAYOUT.FULL_SCREEN

  return (
    <div
      role={"alert"}
      className={isFullScreen ? "fixed z-30 top-0 left-0 w-full h-full bg-gradient-ocean p-4" : "grow p-4"}
    >
      <div
        className={
          "relative glasseffect-xl bg-neutral-white/50 rounded-xl h-full w-full flex justify-center items-center overflow-x-hidden overflow-y-auto"
        }
      >
        {isFullScreen && (
          <Tatami className={"invisible md:visible absolute bottom-14 text-[#DBDBDB] no-fill w-11/12"} />
        )}
        <div
          className={
            "w-full max-w-6xl flex flex-col-reverse lg:flex-row items-center justify-between gap-8 lg:gap-16 z-10 px-6 py-10"
          }
        >
          <div className={"flex flex-col gap-5 items-start max-w-xl"}>
            <h1 className={"display-md-bold text-neutral-gray-900"}>{t("app:errorBoundary.title")}</h1>
            <p className={"body-md-regular text-neutral-gray-600"}>{t("app:errorBoundary.subtitle")}</p>
            {isStillFailing && (
              <p className={"body-md-regular text-neutral-gray-600"}>{t("app:errorBoundary.stillFailing")}</p>
            )}
            <Button
              variant={"button-primary-initial-big"}
              loading={isRecovering}
              onClick={reload}
            >
              {t("app:errorBoundary.action")}
            </Button>
          </div>
          <RepairIllustration isRepairing={isRecovering} />
        </div>
      </div>
    </div>
  )
}
